{
    "SchedulereportLabel": "Programmare questo rapporto:",
    "SchedulereportNotscheduledOptionLabel": "[Non in programma]",
    "SchedulereportOnceOptionLabel": "Una volta",
    "SchedulereportHourlyOptionLabel": "Orario",
    "SchedulereportDailyOptionLabel": "Giornaliero",
    "SchedulereportWeeklyOptionLabel": "Settimanale",
    "SchedulereportMonthlyOptionLabel": "Mensile",
    "SchedulereportResetButtonLabel": "Reset",
    "SchedulereportPromptReset": "Siete sicuri di voler reimpostare il programma?",
    "SchedulereportPromptButtonConfirmLabel": "Confermare",
    "SchedulereportPromptButtonCancelLabel": "Annullamento",
    "ReportScheduling_SectionHeader": "Pianificazione dei rapporti",
    "NAME": "ReportScheduling"
}